const generateMarks = (values: number[]) => values.map((value) => ({ label: `${value}x`, value }));

/** Evenly spaced leverage marks; last mark is always the exact ceiling. Dedupes collapsed floors. */
export const getLeverageMarks = (leverage: number) => {
  if (leverage <= 1) return generateMarks([1]);

  const raw = [
    1,
    Math.floor(leverage / 5),
    Math.floor((leverage * 2) / 5),
    Math.floor((leverage * 3) / 5),
    Math.floor((leverage * 4) / 5),
    leverage,
  ];

  const values = [...new Set(raw.filter((value) => value >= 1 && value <= leverage))];
  if (values[values.length - 1] !== leverage) values.push(leverage);

  return generateMarks(values);
};

export const PercentMarks = [
  { label: '0%', value: 0 },
  { label: '25%', value: 25 },
  { label: '50%', value: 50 },
  { label: '75%', value: 75 },
  { label: '100%', value: 100 },
];
